module.exports = __webpack_public_path__ + "img/img18.6ff3c1d0.png";